<div
  class="arrange-placeholder flex flex-column align-items-center justify-content-center h-full w-full gap-2 text-color-secondary">
  @if (display) {
    <span
      class="arrange-placeholder__icon flex align-items-center justify-content-center border-round-lg flex-shrink-0">
      <i [class]="display.icon"></i>
    </span>
    @if (showLabel) {
      <span class="arrange-placeholder__label text-center">{{
        headline || display.label
      }}</span>
    }
  }
</div>
